import React, { useCallback } from 'react';
import FormsBoilerplate from '../../Components/Boilerplates/Forms/Forms';
import { useDispatch } from 'react-redux';
import * as actionCreators from '../../store/index';
import './Login.scss';

const initialState = [
  {
    id: 'username',
    elementConfig: {
      type: 'text',
      placeholder: 'نام کاربری',
    },
    direction: true,
    value: '',
    validation: {
      required: true,
      minLength: 4,
    },
    valid: false,
    touched: false,
    errorMessages: ['لطفا نام کاربری خود را وارد کنید', 'نام کاربری حداقل شامل 4 حرف است'],
  },
  {
    id: 'password',
    elementConfig: {
      type: 'password',
      placeholder: 'رمز عبور',
    },
    direction: true,
    value: '',
    validation: {
      required: true,
      minLength: 4,
    },
    valid: false,
    touched: false,
    errorMessages: ['لطفا رمز عبور خود را وارد کنید', 'رمز عبور باید حداقل شامل 4 حرف باشد'],
  },
];

const Login = () => {
  const dispatch = useDispatch();

  const handleResponse = useCallback(
    (data, setMessage) => {
      if (data.code) {
        setMessage({
          message: data.code,
          type: 'error',
        });
      } else {
        dispatch(
          actionCreators.authorizeUser({
            accessToken: data.access,
            refreshToken: data.refresh,
          })
        );
      }
    },
    [dispatch]
  );

  return (
    <FormsBoilerplate
      inputs={initialState}
      url={'api/token/'}
      handleResponse={handleResponse}
      pageTitle={'ورود'}
      noLogout
    />
  );
};

export default Login;
